import { gql } from 'graphql-tag';

// Portfolio operations against the Nexus backend.
//
// GENERATED - do not hand-edit. Regenerate with:
//   node scripts/gen-portfolio-query.js --write
//
// The selection is built from the LIVE schema by introspection, because a field this query
// forgets to select is indistinguishable from a field the person left blank: the portfolio
// screens copy `res[key]` for the keys of a local reactive. Hand-maintaining it had already
// drifted ~168 fields behind, including the whole `intake` block the AIPM availability grid
// reads. Do not trust a committed schema.gql - the one on main lacks stateId, and the one
// codegen.yml points at predates intake entirely.
//
// `id` is aliased to `_id` throughout: every call site reads `_id`, and m-checkout-form
// derives studentPortfolioId from it with five saves that hard-abort when it is empty.

export const USER_PORTFOLIO_QUERY = gql`
  query UserPortfolio {
    userPortfolio {
      completionStatus {
        employerProfile
        generalProfile
        organizerProfile
        overallComplete
        parentProfile
        percentComplete
        schoolProfile
        studentProfile
        teacherProfile
      }
      employer {
        airtable {
          airtable_id
          created_at
          last_modified_at
          spreadsheet
        }
        deletedAt
        employerName
        _id: id
        industry
        jobTitle
        last_modified_at
        last_synced_at
        organizerName
        primaryProduct
        work {
          city
          country
          countryCode
          county
          formattedAddress
          geocodeConfidence
          geocodeSource
          geocodedAt
          isPrivate
          lat
          lng
          placeId
          state
          stateCode
          streetAddress
          typeName
          zipcode
        }
      }
      organizer {
        district
        _id: id
        industry
        jobTitle
        organizerName
        position
        primaryProduct
        schoolDistrict
        staffType
        work {
          city
          state
          streetAddress
          zipcode
        }
      }
      parent {
        airtable {
          airtable_id
          created_at
          last_modified_at
          spreadsheet
        }
        currentEmployer
        deletedAt
        email
        _id: id
        last_modified_at
        last_synced_at
        linkedIn
        parent {
          city
          country
          countryCode
          county
          currentEmployer
          formattedAddress
          geocodeConfidence
          geocodeSource
          geocodedAt
          isPrivate
          lat
          lng
          placeId
          positionTitle
          state
          stateCode
          streetAddress
          typeName
          zipcode
        }
        positionTitle
        reSkill
      }
      school {
        airtable {
          airtable_id
          created_at
          last_modified_at
          spreadsheet
        }
        deletedAt
        district {
          city
          country
          countryCode
          county
          formattedAddress
          geocodeConfidence
          geocodeSource
          geocodedAt
          lat
          lng
          placeId
          state
          stateCode
          streetAddress
          typeName
          zipcode
        }
        _id: id
        last_modified_at
        last_synced_at
        position
        schoolDistrict
        staffType
      }
      student {
        airtable {
          airtable_id
          created_at
          last_modified_at
          spreadsheet
        }
        date
        deletedAt
        ethnicity
        gender
        grade
        guardian {
          email
          firstName
          lastName
          phoneNumber
          phoneVerified
          relationship
          typeName
        }
        home {
          city
          country
          countryCode
          county
          formattedAddress
          geocodeConfidence
          geocodeSource
          geocodedAt
          isPrivate
          language
          lat
          lng
          placeId
          state
          stateCode
          streetAddress
          typeName
          zipcode
        }
        _id: id
        intake {
          additionalExperiences
          availability {
            fri
            mon
            sat
            sun
            thu
            tue
            wed
          }
          calendarAck
          careers
          deliverables
          followsPilotcityInstagram
          goals
          inPersonFrequency
          inPersonInterest
          instagramHandle
          jobs
          linkedinUrl
          localEmployers
          maxWeeklyHours
          minWeeklyHours
          moreSummerClasses
          moreVacations
          notes
          obligations
          otherExperiences
          otherObligations
          partTimeJobCompany
          partTimeJobEndDate
          partTimeJobStartDate
          partTimeJobWorkHours
          passions
          pmfSentiment
          problems
          programManagerAck
          schoolStartDate
          skills
          socialMedia
          sponsorshipIdeal
          sponsorshipMin
          strengths
          summerCity
          summerClassesEndDate
          summerClassesStartDate
          tiktokHandle
          tools
          transportation
          updatedAt
          users
          vacationCommsAvailable
          vacationEndDate
          vacationStartDate
          youtubeHandle
        }
        invited
        isUserNotExists
        last_modified_at
        last_synced_at
        school {
          city
          country
          countryCode
          county
          district
          formattedAddress
          geocodeConfidence
          geocodeSource
          geocodedAt
          lat
          lng
          name
          placeId
          state
          stateCode
          streetAddress
          typeName
          zipcode
        }
        stateId
        studentId
      }
      teacher {
        airtable {
          airtable_id
          created_at
          last_modified_at
          spreadsheet
        }
        deletedAt
        _id: id
        last_modified_at
        last_synced_at
        schoolDistrict
        schoolName
        schools {
          city
          country
          countryCode
          county
          formattedAddress
          geocodeConfidence
          geocodeSource
          geocodedAt
          lat
          lng
          placeId
          state
          stateCode
          streetAddress
          typeName
          zipcode
        }
        subjects
      }
      user {
        email
        firstName
        _id: id
        lastName
        phoneNumber
        profileImg
        userId
        userTypes
      }
    }
  }
`;

export const UPDATE_PORTFOLIO_MUTATION = gql`
  mutation UpdatePortfolio($input: UpdatePortfolioInput!) {
    updatePortfolio(input: $input) {
      success
      message
      portfolio {
        completionStatus {
          employerProfile
          generalProfile
          organizerProfile
          overallComplete
          parentProfile
          percentComplete
          schoolProfile
          studentProfile
          teacherProfile
        }
        employer {
          airtable {
            airtable_id
            created_at
            last_modified_at
            spreadsheet
          }
          deletedAt
          employerName
          _id: id
          industry
          jobTitle
          last_modified_at
          last_synced_at
          organizerName
          primaryProduct
          work {
            city
            country
            countryCode
            county
            formattedAddress
            geocodeConfidence
            geocodeSource
            geocodedAt
            isPrivate
            lat
            lng
            placeId
            state
            stateCode
            streetAddress
            typeName
            zipcode
          }
        }
        organizer {
          district
          _id: id
          industry
          jobTitle
          organizerName
          position
          primaryProduct
          schoolDistrict
          staffType
          work {
            city
            state
            streetAddress
            zipcode
          }
        }
        parent {
          airtable {
            airtable_id
            created_at
            last_modified_at
            spreadsheet
          }
          currentEmployer
          deletedAt
          email
          _id: id
          last_modified_at
          last_synced_at
          linkedIn
          parent {
            city
            country
            countryCode
            county
            currentEmployer
            formattedAddress
            geocodeConfidence
            geocodeSource
            geocodedAt
            isPrivate
            lat
            lng
            placeId
            positionTitle
            state
            stateCode
            streetAddress
            typeName
            zipcode
          }
          positionTitle
          reSkill
        }
        school {
          airtable {
            airtable_id
            created_at
            last_modified_at
            spreadsheet
          }
          deletedAt
          district {
            city
            country
            countryCode
            county
            formattedAddress
            geocodeConfidence
            geocodeSource
            geocodedAt
            lat
            lng
            placeId
            state
            stateCode
            streetAddress
            typeName
            zipcode
          }
          _id: id
          last_modified_at
          last_synced_at
          position
          schoolDistrict
          staffType
        }
        student {
          airtable {
            airtable_id
            created_at
            last_modified_at
            spreadsheet
          }
          date
          deletedAt
          ethnicity
          gender
          grade
          guardian {
            email
            firstName
            lastName
            phoneNumber
            phoneVerified
            relationship
            typeName
          }
          home {
            city
            country
            countryCode
            county
            formattedAddress
            geocodeConfidence
            geocodeSource
            geocodedAt
            isPrivate
            language
            lat
            lng
            placeId
            state
            stateCode
            streetAddress
            typeName
            zipcode
          }
          _id: id
          intake {
            additionalExperiences
            availability {
              fri
              mon
              sat
              sun
              thu
              tue
              wed
            }
            calendarAck
            careers
            deliverables
            followsPilotcityInstagram
            goals
            inPersonFrequency
            inPersonInterest
            instagramHandle
            jobs
            linkedinUrl
            localEmployers
            maxWeeklyHours
            minWeeklyHours
            moreSummerClasses
            moreVacations
            notes
            obligations
            otherExperiences
            otherObligations
            partTimeJobCompany
            partTimeJobEndDate
            partTimeJobStartDate
            partTimeJobWorkHours
            passions
            pmfSentiment
            problems
            programManagerAck
            schoolStartDate
            skills
            socialMedia
            sponsorshipIdeal
            sponsorshipMin
            strengths
            summerCity
            summerClassesEndDate
            summerClassesStartDate
            tiktokHandle
            tools
            transportation
            updatedAt
            users
            vacationCommsAvailable
            vacationEndDate
            vacationStartDate
            youtubeHandle
          }
          invited
          isUserNotExists
          last_modified_at
          last_synced_at
          school {
            city
            country
            countryCode
            county
            district
            formattedAddress
            geocodeConfidence
            geocodeSource
            geocodedAt
            lat
            lng
            name
            placeId
            state
            stateCode
            streetAddress
            typeName
            zipcode
          }
          stateId
          studentId
        }
        teacher {
          airtable {
            airtable_id
            created_at
            last_modified_at
            spreadsheet
          }
          deletedAt
          _id: id
          last_modified_at
          last_synced_at
          schoolDistrict
          schoolName
          schools {
            city
            country
            countryCode
            county
            formattedAddress
            geocodeConfidence
            geocodeSource
            geocodedAt
            lat
            lng
            placeId
            state
            stateCode
            streetAddress
            typeName
            zipcode
          }
          subjects
        }
        user {
          email
          firstName
          _id: id
          lastName
          phoneNumber
          profileImg
          userId
          userTypes
        }
      }
    }
  }
`;
